import { useCallback, useState } from 'react';

// Armazenar callbacks de atualização
const refreshCallbacks: Set<() => void> = new Set();

export const useVehiclesRefresh = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Registrar um callback para ser chamado quando precisar atualizar
  const registerRefreshCallback = useCallback((callback: () => void) => {
    refreshCallbacks.add(callback);
    return () => {
      refreshCallbacks.delete(callback);
    };
  }, []);

  // Trigger para atualizar a lista
  const triggerRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
    refreshCallbacks.forEach(callback => callback());
  }, []);

  return {
    refreshTrigger,
    registerRefreshCallback,
    triggerRefresh,
  };
};

// Instância global para ser compartilhada
let globalVehiclesRefresh: any = null;

export const setGlobalVehiclesRefresh = (refresh: any) => {
  globalVehiclesRefresh = refresh;
};

export const triggerGlobalVehiclesRefresh = () => {
  if (globalVehiclesRefresh) {
    globalVehiclesRefresh.triggerRefresh();
  }
};
